import {
  CButton,
  CButtonGroup,
  CCol,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem, updateItem, ItemRequestStatus } from "../../api/generics";
import Color, { newColor } from "../../models/color";
import Errors, { getFieldErrors } from "../../models/errors";
import { SUCCESS } from "../../utils/constants/tags";
import { FieldErrors } from "../form/FieldErrors";
import { errorAlert } from "../utils/messages";
import { emptyValueOnUndefined } from "../../utils/fields";
import { RootState } from "../../store";
import { useSelector } from "react-redux";

interface ColorFormProps {
  initialColor?: Color;
  initialErrors?: Errors;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const ColorForm: React.FC<ColorFormProps> = ({
  initialColor,
  initialErrors,
  onCancel,
  onSuccess,
}) => {
  const company = useSelector((state: RootState) => state.company.data.company);
  const [editingColor, setEditingColor] = useState<Color>(
    initialColor ? initialColor : newColor()
  );

  const [errors, setErrors] = useState<Errors>(
    initialErrors ? initialErrors : {}
  );
  const [submitting, setSubmitting] = useState(false);

  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingColor({
      ...editingColor,
      color: e.target.value,
    });
  };

  const onSave = async () => {
    setSubmitting(true);
    let toSendColor = {
      ...editingColor,
      companyId: company.id,
    };
    let requestPromise: Promise<ItemRequestStatus<Color>>;
    if (editingColor.id === undefined) {
      requestPromise = createItem<Color>("/colors/create/", toSendColor);
    } else {
      requestPromise = updateItem<Color>(
        `/colors/${toSendColor.id}/`,
        toSendColor
      );
    }

    const colorStatus = await requestPromise;

    if (colorStatus.status !== SUCCESS) {
      if (colorStatus.errors !== undefined) {
        setErrors(colorStatus.errors);
      }

      let message = "Ha ocurrido un error!!";
      if (colorStatus.detail !== undefined) {
        message = colorStatus.detail;
      }
      errorAlert(message);
    } else {
      setErrors({});
      clearForm();
      onSuccess();
    }
    setSubmitting(false);
  };

  const onClose = () => {
    clearForm();
    onCancel();
  };

  const clearForm = () => {
    setEditingColor(newColor());
  };

  useEffect(() => {
    setEditingColor(initialColor ? initialColor : newColor());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialColor]);

  useEffect(() => {
    setErrors(initialErrors ? initialErrors : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialErrors]);

  return (
    <>
      <fieldset disabled={submitting}>
        <CFormGroup>
          <CRow>
            <CCol md={2}>
              <CLabel>Nombre:</CLabel>
            </CCol>
            <CCol>
              <CInput
                type="text"
                value={emptyValueOnUndefined(editingColor.color)}
                onChange={onNameChange}
                placeholder="Nombre de color"
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("color", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup className="float-right">
          <CButtonGroup>
            <CButton type="button" color="secondary" onClick={onClose}>
              Atras
            </CButton>
            <CButton type="submit" color="primary" onClick={onSave}>
              {submitting ? (
                <Spinner
                  animation="grow"
                  style={{
                    height: "17px",
                    width: "17px",
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginRight: "10px",
                  }}
                />
              ) : (
                <></>
              )}
              {submitting ? "Guardando..." : "Guardar"}
            </CButton>
          </CButtonGroup>
        </CFormGroup>
      </fieldset>
    </>
  );
};

export default ColorForm;
